import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OffCanvasStateService {
  private leftOffCanvasOpenSubject = new BehaviorSubject<boolean>(true);

  leftOffCanvasOpen$: Observable<boolean> = this.leftOffCanvasOpenSubject.asObservable();

  setLeftOffCanvasOpen(isOpen: boolean): void {
    this.leftOffCanvasOpenSubject.next(isOpen);
  }

  getLeftOffCanvasOpen(): boolean {
    return this.leftOffCanvasOpenSubject.value;
  }
}
